angular.module('impactx.smartform').controller('SmartFormEditorTestCtrl', [
    '$scope',
    SmartFormEditorTestController]);

function SmartFormEditorTestController($scope) {
    $scope.formConfig = {
        "identifier": "TestXYZ",
        "entries": [],
    }
}